module.exports = __webpack_public_path__ + "img/viator.7d5bf960.svg";